module.exports = __webpack_public_path__ + "static/Lauv_Black Logo-0572f5861babd9dbfee8af91e24c837d.png";